module.exports = __webpack_public_path__ + "img/monitoring-car-red.6563230b.svg";